import { CarouselItem } from '../../../models/item';
import { html } from 'lit-html';
import { each } from '../../../component';
import { ReviewArea } from '../../common/item_cassette/review_area';
import { ItemImage, ItemLink, PriceArea } from '../../common/item_cassette/price_image_link';

let isUserLogin: boolean;
/**
 * カルーセルの商品エリア、RR外部流入版
 * @param carouselItems カルーセル商品リスト
 */
export const CarouselItemsFromExternalSite = (carouselItems: CarouselItem[], isLogin: boolean, carouselId: string, perView: number = 3) => {
  isUserLogin = isLogin;
  return html`
    <div class="o-carousel js-lazy-img js-carousel -pagination" id="${carouselId}">
      <div
        class="swiper-container js-carousel-body"
        data-type="pagination"
        data-perview="${perView}"
        data-space="24"
        data-colfixed="true"
      >
        <div class="swiper-wrapper">
          ${each(carouselItems, CarouselItemAreaFromExternalSite)}
        </div>
      </div>
      <div class="o-carousel_pagination js-carousel_pagination">
        ページ：
        <span class="o-carousel_count js-carousel_count"></span>
        <a href="#" class="a-textlink o-carousel_toFirst js-carousel_toFirst">最初に戻る</a>
      </div>
      <button class="a-ctrlbtn js-lazy-img -prev o-carousel_prev js-carousel_prev" type="button">
        <span class="a-ctrlbtn_text">前のスライドへ</span>
      </button>
      <button class="a-ctrlbtn js-lazy-img -next o-carousel_next js-carousel_next" type="button">
        <span class="a-ctrlbtn_text">次のスライドへ</span>
      </button>
    </div>
  `;
};

/**
 * カルーセル商品単品、RR外部流入版
 * @param carouselItem カルーセル-商品情報
 */
const CarouselItemAreaFromExternalSite = (carouselItem: CarouselItem) => html`
  <div class="o-carousel_slide swiper-slide js-carousel_slide">
    <div class="o-carousel_slideinner">
      <div class="m-simpleitemcard -horizontal">
        <div class="m-simpleitemcard_inner">
          <div class="m-simpleitemcard_body">
            <div class="m-simpleitemcard_name">
              <p class="a-text">
                <a
                  href=${ItemLink(carouselItem.supplierId, carouselItem.itemCode, carouselItem.isVariation, carouselItem.rrLinkUrl)}
                  data-maxline="2"
                  title="${carouselItem.itemName}"
                  class="a-textlink u-maxline">${carouselItem.itemName}
                </a>
              </p>
            </div>
            ${ReviewArea(carouselItem)}
            ${PriceArea(
              carouselItem.salesPriceTaxInclude,
              carouselItem.isVariation,
              carouselItem.isMedical,
              isUserLogin
            )}
          </div>
          <div class="m-simpleitemcard_section">
            <a
              href=${ItemLink(carouselItem.supplierId, carouselItem.itemCode, carouselItem.isVariation, carouselItem.rrLinkUrl)}
              title="${carouselItem.itemName}"
              class="m-simpleitemcard_link">
              <div class="m-simpleitemcard_img">
                <div class="a-img -radius">
                  <span class="a-img_imgWrap">
                    ${ItemImage(carouselItem.imageUrl, carouselItem.itemName)}
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
`;
